import script from "./HsSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./HsSidebar.vue?vue&type=script&setup=true&lang=js"

import "./HsSidebar.vue?vue&type=style&index=0&id=01a8e29c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a8e29c"]])

export default __exports__